import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Spinner } from 'react-bootstrap'
import LightBox from 'components/molecules/Lightbox'
import { get } from 'lodash'
import { userCheckMobileScreen } from 'helpers/tools'
import classnames from 'classnames'

import './MediaGrid.scss'

const MediaGrid = ({ medias, className }) => {
  const qtdInitialPictures = 24
  const [loadedImages, setLoadedImages] = useState(medias?.slice(0, qtdInitialPictures))
  const [isInViewport, setIsInViewport] = useState(false)
  const [hasMorePictures, setHasMorePictures] = useState(true)
  const bottomRef = useRef(null)
  const containerRef = useRef(null)

  // Load more pictures when the user scroll to the bottom of the page
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => entry.isIntersecting && setIsInViewport(true), {
      threshold: 1,
    })

    if (bottomRef.current) {
      observer.observe(bottomRef.current)
    }

    if (isInViewport && hasMorePictures) {
      if (loadedImages.length < medias.length) {
        setLoadedImages(medias?.slice(0, loadedImages.length + 12))
      } else {
        setHasMorePictures(false)
      }
    }

    return () => {
      setIsInViewport(false)
      observer.disconnect()
    }
  })

  return (
    <>
      <Row>
        {loadedImages?.map(({ entity }, index) => (
          <Col
            xs={6}
            md={3}
            className={classnames("mb-3 mb-md-4 px-2", className)}
            key={'album' + get(entity, 'images.src') + index}
            ref={containerRef}
          >
            <LightBox
              allImages={medias.map(({ entity }) => ({ image: entity?.images }))}
              className="media-grid__image bg-gray-400"
              image={userCheckMobileScreen() ? entity?.images?.medium?.url : entity?.images?.large?.url}
              imageAlt={entity?.images?.alt}
              index={index}
            />
          </Col>
        ))}
      </Row>
      {hasMorePictures && (
        <Row>
          <div className="text-center w-100">
            <Spinner ref={bottomRef} animation="border" />
          </div>
        </Row>
      )}
    </>
  )
}


MediaGrid.defaultProps = {
  className: '',
}

MediaGrid.propTypes = {
  medias: PropTypes.array,
  className: PropTypes.string,
}

export default MediaGrid